export default "__VITE_ASSET__B0Npm0ss__"